import { Flex } from "@chakra-ui/react";
import Logo from "../../../assets/img/Logo.svg";
import Vezarat from "../../../assets/img/amoozesh-logo.png";
import { IMainLogoProps } from "types/common/IMainLogoProps";

export const MainLogo = ({
  logoProps,
  vezaratProps,
  ...flexProps
}: IMainLogoProps) => {
  return (
    <Flex
      direction="column"
      alignItems="center"
      justifyContent="center"
      className="mainlogoContainer"
      {...flexProps}
    >
      <img src={Logo} className="header-logo" {...logoProps} />
      <img src={Vezarat} className="main-logo-text" {...vezaratProps} />
    </Flex>
  );
};
